import useComponentDidMount from 'Hooks/useComponentDidMount';
import { legacyPageRoutes } from 'Views/Page/Content/Templates/RedirectTemplate/legacyPageRoutes';
import history from 'State/history';
import useUserContext from 'Context/UserContext';
import isDev from 'Helpers/isDev';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';

const RedirectTemplate = ({ collection }) => {
  const { isAgent } = useUserContext();
  const { householdResource } = useSimpleHousehold();

  useComponentDidMount(() => {
    const legacyPageRouteFn = legacyPageRoutes[collection.meta().type()];
    if (legacyPageRouteFn) {
      history.replace(legacyPageRouteFn(collection.link('self').url(), isAgent, collection, history, householdResource));
    } else if (isDev()) {
      throw new Error(`resource type "${collection.meta().type()}" is missing from legacyPageRoutes. Add type to legacyPageRoutes`);
    }
  });

  return null;
};

export default RedirectTemplate;
